import {
  incidentCustomerOptionsPageSchema,
  incidentDetailSchema,
  incidentPageSchema,
} from '@solidops/shared/incidents';
import { phoneProgressSchema } from '@solidops/shared/phone';

import { validatedFetch } from './client.js';

/** Validate the original response before generated object schemas can strip private fields. */
export function validatedIncidentFetch<T>(
  url: string,
  options?: Parameters<typeof validatedFetch>[1],
): Promise<T> {
  const path = url.split('?', 1)[0];
  const schema =
    path === '/api/v1/incidents'
      ? incidentPageSchema
      : path?.endsWith('/customer-options')
        ? incidentCustomerOptionsPageSchema
        : path?.endsWith('/phone')
          ? phoneProgressSchema
          : incidentDetailSchema;
  return validatedFetch<T>(url, { ...options, schema });
}
